import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(
  () => import("../components/approval/resultSpreadsheet/main"),
);

const ResultSpreadsheet = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ResultSpreadsheet;
